<template>
    <div class="business-content-main"  v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="search-name">汽配编码</div>
                    <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="请输入汽配编码"></el-input>
                    <div class="search-name">合作项目</div>
                    <el-select class="search-item" size="small" v-model="searchData.Projects" @visible-change="coProjectsVisibleChange($event)">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in projectsList" :key="item.ProjectId" :label="item.ProjectName" :value="item.ProjectId"></el-option>
                    </el-select>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <el-button size="small" class="search-btn btn-primary" @click="showSearchDialog">更多条件（F2）</el-button>
                    <el-button size="small" class="search-btn btn-primary" v-if="permission.export" @click="exportData">
                        <i class="fa fa-file-excel-o"></i>
                        {{ permission.export }}</el-button
                    >                    
                </div>
            </div>
            <div>
                <el-card class="box-card">
                    <div class="data-count">
                        <div class="data-item">
                            <p>销售总额</p>
                            <p>￥{{ statData.saleTotal.toFixed(2) }}</p>
                        </div>
                        <div class="data-item">
                            <p>销售总数</p>
                            <p>{{ statData.saleGoodsTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>采购总数</p>
                            <p>
                                {{ statData.purGoodsTotal}}
                            </p>
                        </div>
                        <div class="data-item">
                            <p>采购总额</p>
                            <p>￥{{ statData.purTotal.toFixed(2) }}</p>
                        </div>
                        <div class="data-item">
                            <p>销售退货总数</p>
                            <p>{{ statData.saleReturnGoodsTotal}}</p>
                        </div>
                        <div class="data-item">
                            <p>销售退货总额</p>
                            <p>￥{{ statData.saleReturnTotal.toFixed(2) }}</p>
                        </div>
                        <div class="data-item">
                            <p>采购退货总数</p>
                            <p>
                                {{ statData.purReturnGoodsTotal }}
                            </p>
                        </div>
                        <div class="data-item">
                            <p>采购退货总额</p>
                            <p>￥{{ statData.purReturnTotal.toFixed(2) }}</p>
                        </div>
                        <div class="data-item">
                            <p>
                                <el-tooltip effect="dark" placement="bottom">
                                    <div slot="content">总成本 = 销售出库成本 - 销售退货成本</div>
                                    <span>
                                        <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                    </span> </el-tooltip
                                >总成本
                            </p>
                            <p style="color: red; font-size: 16px">￥{{ (statData.costTotal).toFixed(2) }}</p>
                        </div>
                        <div class="data-item border-right-none">
                            <p>
                                <el-tooltip effect="dark" placement="bottom">
                                    <div slot="content">总利润 = {（销售价格 - 成本价）* 销售总数 - （销售退货价格 - 成本价） * 销售退货总数） }</div>
                                    <span>
                                        <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                    </span> </el-tooltip
                                >总利润
                            </p>
                            <p style="color: green; font-size: 16px">￥{{ (statData.profitTotal).toFixed(2) }}</p>
                        </div>
                    </div>
                </el-card>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border
                    style="width: 100%"
                    :default-sort="{ prop: 'SaleTotalAmount', order: 'descending' }"
                    @sort-change="sortChange"
                    :tableCode="tableCode"
                >
                    <template v-for="(col,index) in columnShowSets">
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-if="col.ColumnCode == 'Index'"
                            :index="indexMethod"
                            type="index"
                            fixed="left"
                            show-overflow-tooltip
                        >
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else-if="col.ColumnCode == 'SaleTotalAmount'"
                        >
                            <template slot="header">
                                {{ col.ColumnName }}
                            </template>
                            <template slot-scope="scope">{{ scope.row.SaleTotalAmount.toFixed(2) }} </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else-if="col.ColumnCode == 'PurchaseTotalAmount'"
                        >
                            <template slot="header">
                                {{ col.ColumnName }}
                            </template>
                            <template slot-scope="scope">{{ scope.row.PurchaseTotalAmount.toFixed(2) }} </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else-if="col.ColumnCode == 'SaleReturnTotalAmount'"
                        >
                            <template slot="header">
                                {{ col.ColumnName }}
                            </template>
                            <template slot-scope="scope">{{ scope.row.SaleReturnTotalAmount.toFixed(2) }} </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else-if="col.ColumnCode == 'PurchaseReturnTotalAmount'"
                        >
                            <template slot="header">
                                {{ col.ColumnName }}
                            </template>
                            <template slot-scope="scope">{{ scope.row.PurchaseReturnTotalAmount.toFixed(2) }} </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else-if="col.ColumnCode == 'SaleTotalCost'"
                        >
                            <template slot="header">
                                {{ col.ColumnName }}
                            </template>
                            <!-- <template slot-scope="scope">{{ (scope.row.SaleTotalCost - scope.row.SaleReturnTotalAmount).toFixed(2) }}</template> -->
                            <template slot-scope="scope">{{ (scope.row.SaleTotalCost).toFixed(2) }}</template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else-if="col.ColumnCode == 'SaleTotalProfit'"
                        >
                            <template slot="header">
                                {{ col.ColumnName }}
                            </template>
                            <!-- <template slot-scope="scope">{{ (scope.row.SaleTotalProfit - scope.row.SaleReturnTotalAmount).toFixed(2) }}</template> -->
                             <template slot-scope="scope">{{ (scope.row.SaleTotalProfit).toFixed(2) }}</template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else
                        >
                        </el-table-column>
                    </template>
                    <el-table-column fixed="right" label="操作" width="105px" :isCanSet="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <img class="image-sup" src="@/assets/images/sup.png" title="采购历史" @click="showHistories(scope.row.Id)" />
                                <img class="image-cus" src="@/assets/images/cus.png" title="销售历史" @click="showSaleStat(scope.row)" />
                                <img src="@/assets/images/analysis.png" style="width: 22px; height: 22px; margin-left: 6px" title="数据分析" @click="analysis(scope.row)" />
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
            <el-dialog :close-on-click-modal="false" title="采购历史" :visible.sync="historyVisible" width="1200px">
                <div v-if="historyVisible">
                    <APPurchaseHistory :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeHistoryDialog"></APPurchaseHistory>
                </div>
            </el-dialog>
            <!-- 销售历史 -->
            <el-dialog :title="SaleDialogTitle" :close-on-click-modal="false" :visible.sync="eyeHistoryVisible" append-to-body width="1200px">
                <div v-if="eyeHistoryVisible">
                    <APHistory :showCusColumn="false" :EntpTempGoodsId="APId" @closeDialog="eyeHistoryVisible = false"></APHistory>
                </div>
            </el-dialog>
            <!-- 数据分析 -->
            <el-dialog :close-on-click-modal="false" title="商品销售采购数据图表" :visible.sync="goodsAnalysisVisible" width="1200px">
                <div class="dialog-content" v-if="goodsAnalysisVisible">
                    <goodsAnalysis :GoodsId="APId" @closeDialog="goodsAnalysisVisible = false"></goodsAnalysis>
                </div>
            </el-dialog>
            <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
            <div style="z-index: 2001" class="exportmsg" v-if="showExportMsg">
                <span>数据已经准备好，正在生成Excel表格，可能耗时1-5min，请耐心等候……</span>
                <span>您也可以打开新的窗口进行其他的操作</span>
            </div>    
            <el-dialog
                :close-on-click-modal="false"
                title="更多搜索"
                :visible.sync="searchDialogVisible"
                width="400px"
                append-to-body
                v-dialog-drag
                lock-scroll
                :modal="false"
                id="search-page-dialog"
                custom-class="search-item-dialog"
                style="margin-left: -170px"
            >
                <div class="dialog-content" v-if="searchDialogVisible">
                    <el-form ref="form" label-position="left" label-width="75px">
                        <el-form-item label="汽配编码">
                            <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="汽配编码"></el-input>
                        </el-form-item>
                        <el-form-item label="汽配名称" v-if="isExObj('GoodName')">
                            <el-select
                                size="small"
                                style="width: 100%"
                                v-model="searchData.GoodName"
                                remote
                                filterable
                                allow-create
                                clearable
                                placeholder="请输入配件名称"
                                :remote-method="searchGoodName"
                                v-select-scroll-more="searchGoodNameLoad"
                                popper-class="my-select"
                            >
                                <el-option v-for="item in goodNameOptions" :key="item" :label="item" :value="item"> </el-option>
                                <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                    加载中
                                    <i class="el-icon-loading"></i>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="适用车型" v-if="isExObj('AutoSerise')">
                            <el-select
                                size="small"
                                style="width: 100%"
                                v-model="searchData.AutoSerise"
                                remote
                                filterable
                                allow-create
                                clearable
                                placeholder="请输入车型"
                                :remote-method="searchAutoSerise"
                                v-select-scroll-more="searchAutoSeriseLoad"
                                popper-class="my-select"
                            >
                                <el-option v-for="item in autoSeriseOptions" :key="item" :label="item" :value="item" style="width: 300px"> </el-option>
                                <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                    加载中
                                    <i class="el-icon-loading"></i>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="汽配品牌" v-if="isExObj('Brand')">
                            <el-select
                                v-model="searchData.BrandName"
                                multiple
                                collapse-tags
                                filterable
                                clearable
                                size="small"
                                style="width: 100%"
                                @visible-change="brandVisibleChange($event)"
                            >
                                <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="汽配分类" v-if="isExObj('APCate')">
                            <el-select
                                size="small"
                                style="width: 100%"
                                v-model="searchData.APCate"
                                multiple
                                collapse-tags
                                filterable
                                clearable
                                @visible-change="cateVisibleChange($event)"
                            >
                                <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                    <div class="option-content">
                                        <div>{{ optionItem.Text }}</div>
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="合作项目">
                            <el-select style="width: 100%" size="small" v-model="searchData.Projects" @visible-change="coProjectsVisibleChange($event)">
                                <el-option label="全部" value=""></el-option>
                                <el-option v-for="item in projectsList" :key="item.ProjectId" :label="item.ProjectName" :value="item.ProjectId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="销售区域" v-if="isExObj('ShipAddr')">
                            <el-input class="search-item" size="small" v-model.trim="searchData.Zone" placeholder="销售区域"></el-input>
                        </el-form-item>
                        <el-form-item label="开单时间">
                            <el-date-picker
                                v-model="dateTimes"
                                size="small"
                                class="search-item"
                                type="daterange"
                                align="right"
                                style="width: 100%"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                @change="onDateTimeSelect"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="提交时间">
                            <el-date-picker
                                v-model="dateTimes2"
                                size="small"
                                class="search-item"
                                type="daterange"
                                align="right"
                                style="width: 100%"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                @change="onDateTimeSelect2"
                            ></el-date-picker>
                        </el-form-item>
                    </el-form>
                    <div class="dialog-footer">
                        <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                        <el-button size="small" @click="resetSearch">重置</el-button>
                        <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                    </div>
                </div>
            </el-dialog>   
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import elTableColumn from '@/components/common/chjtablecolumn';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import APPurchaseHistory from '@/components/common/APPurchaseHistory';
import APHistory from '@/components/common/APHistory';
import goodsAnalysis from '@/components/common/goodsAnalysis';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'goodSearch',
    components: {
        breadcrumb,
        APPurchaseHistory,
        APHistory,
        goodsAnalysis,
        elTableColumn
    },
    data() {
        return {
            dateTimes: [],
            dateTimes2: [],
            tableCode: 'ProjectsAutoPartStatTable',
            goodsAnalysisVisible: false,
            historyVisible: false,
            eyeHistoryVisible: false,
            brand: [],
            typeList: [],
            SaleDialogTitle: '',
            PurchaseDialogTitle: '',
            searchData: {
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                APCate: [],
                Zone: '',
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                Projects:'',
                page: 1,
                limit: 15
            },
            statData: {
                saleTotal: 0,
                saleGoodsTotal: 0,
                costTotal: 0,
                profitTotal: 0,
                purTotal: 0,
                purGoodsTotal: 0,
                saleReturnTotal: 0,
                saleReturnGoodsTotal: 0,
                purReturnTotal: 0,
                purReturnGoodsTotal: 0,
                saleReturnCostTotal: 0
            },
            dialogVisible: false,
            searchDialogVisible:false,
            goodsCategories: [],
            tableData: [],
            tableDataLength: 0,
            columnShowSets: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            permission: {},
            saveLoading: false,
            percentage: 0, //进度
            currtPage: 1, //页面，表示保存到第几页,
            saveCount: 0, //已保存数
            showExportMsg: false,
            exportTotalCount: 0, 
            projectsList:[],   
            optionLoading: false,
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            }        
        };
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        if (this.tableCode) this.getSetsData();

        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);
        this.dateTimes2.push(date1);
        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date2 = new Date(year2, month2, day2, 0);
        this.dateTimes2.unshift(date2);

        this.searchData.CStartDate = date2;
        this.searchData.CEndDate = date1;
    },
    mounted() {
        this.permission = this.$util.getPermission('ProjectStat');
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
    },
    watch: {
        dialogVisible(value) {
            if (!value) {
                this.choosedGood = {};
            }
        }
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            if (key === 113) {
                e.preventDefault();
                that.searchDialogVisible = true;
            }
            if (key === 27) {
                e.preventDefault();
                if (that.searchDialogVisible) that.searchDialogVisible = false;
            }
            if (key === 13) {
                e.preventDefault();
                that.handleSearch();
                return;
            }
            //左键
            if (key == 37) {
                e.preventDefault();
                if (this.searchData.page > 1) {
                    this.searchData.page -= 1;
                    this.getTableData();
                }
                return;
            }
            //右键
            if (key == 39) {
                e.preventDefault();
                if (this.searchData.page < Math.ceil(this.tableDataLength / this.searchData.Limit)) {
                    this.searchData.page += 1;
                    this.getTableData();
                }
                return;
            }
        },
        searchGoodsBrand() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .catch(() => {});
        },
        searchGoodsType() {
            this.$util
                .getEntpApCategoryList()
                .then(data => {
                    if (!data) return;
                    this.typeList = data;
                })
                .catch(() => {});
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                APCate: [],
                Zone: '',
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                CStartDate: '',
                CEndDate: '',
                Projects:'',
                page: 1,
                limit: this.commonPageSize
            };
            this.dateTimes = [];
            this.dateTimes2 = [];
        },
        // 关闭弹窗
        closeDialog(edit) {
            this.dialogVisible = false;
            this.choosedGood = {};
            if (edit) {
                this.getTableData();
            }
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosPost({
                    url: '/api/DataStatistics/AutoPartStatistics_ProjectVs',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.tableData=[];
                         this.tableDataLength=0;
                        return;
                    }
                    this.tableData = data.DataList;
                    if(this.searchData.page==1)
                        this.tableDataLength = res.count;                    
                })
                .catch(() => {});
            this.getStatData();
        },
        getStatData() {
            if (this.searchData.page == 1) {
                this.$util
                    .axiosPost({
                        url: '/api/DataStatistics/GetAutoPartStatData_ProjectVs',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        this.statData = {
                            saleTotal: data.SaleTotal,
                            saleGoodsTotal: data.SaleGoodsTotal,
                            costTotal: data.CostTotal,
                            profitTotal: data.ProfitTotal,
                            purTotal: data.PurTotal,
                            purGoodsTotal: data.PurGoodsTotal,
                            saleReturnTotal: data.SaleReturnTotal,
                            saleReturnGoodsTotal: data.SaleReturnGoodsTotal,
                            purReturnTotal: data.PurReturnTotal,
                            purReturnGoodsTotal: data.PurReturnGoodsTotal,
                            // saleReturnCostTotal: data.SaleReturnCostTotal
                        };
                    })
                    .catch(() => {});
            }
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType();
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        indexMethod(index) {
            return index + 1 + (this.searchData.page - 1) * this.searchData.limit;
        },
        //销售数据
        showSaleStat(row) {
            if (row) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.APId = row.Id;
                this.eyeHistoryVisible = true;
            }
        },
        analysis(row) {
            if (row) {
                this.APId = row.Id;
                this.goodsAnalysisVisible = true;
            }
        },
        // 历史销售
        showHistories(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyVisible = true;
            }
        },
        closeHistoryDialog() {
            this.historyVisible = false;
        },
        async searchGoodName(key) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            if (this.goodNameForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                this.goodNameOptions = [...this.goodNameOptions, ...data];
            }
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };
                    this.columnShowSets.push(colums);
                });
            });
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDateTimeSelect2(val) {
            if (val != null) {
                this.searchData.CStartDate = val[0];
                this.searchData.CEndDate = val[1];
            } else {
                this.searchData.CStartDate = '';
                this.searchData.CEndDate = '';
            }
        },
        exportData() {
            let that = this;
            if (that.tableData.length == 0) {
                that.$util.warningMsg('请筛选数据');
                return;
            }
            that.saveLoading = true;
            let saveLimit = 50;
            if (that.tableDataLength < saveLimit) saveLimit = that.tableDataLength;
            // let saveLimit = that.tableDataLength;
            let reqData = { ...that.searchData };
            reqData.limit = saveLimit;
            reqData.page = that.currtPage;
            
            that.$util
                .axiosPost({
                    url: '/api/DataStatistics/GetAutoPartStatsToExport_V2',
                    data: reqData,
                    hideLoading: true
                })
                .then(resp => {
                    let data = resp.data;
                    if (that.currtPage == 1) {
                        if (data.totalCount == 0) {
                            that.percentage = 0;
                            that.saveCount = 0;
                            that.currtPage = 1;
                            that.exportTotalCount = 0;
                            that.saveLoading = false;
                            that.showExportMsg = false;
                            that.$util.warningMsg('没有可导出的数据');
                            return;
                        }
                        that.exportTotalCount = data.totalCount;
                    }
                    that.saveCount += data.count;
                    let num = parseFloat(that.saveCount);
                    let total = parseFloat(that.exportTotalCount);
                    that.percentage = total <= 0 ? 0 : Math.round(Math.round((num / total) * 10000) / 100.0);
                    that.percentage = that.percentage > 100 ? 100 : that.percentage;
                    if (that.exportTotalCount <= that.saveCount) {
                        that.showExportMsg = true;
                        that.$util
                            .exportFile_post({
                                url: '/api/DataStatistics/ExportAutoPartStats_V2',
                                hideLoading:true,
                                data: {
                                    SortProp:that.searchData.SortProp,
                                    SortType:that.searchData.SortType,
                                    TableSetsModels:that.columnShowSets
                                }
                            })
                            .then(res => {
                                that.percentage = 0;
                                that.saveCount = 0;
                                that.currtPage = 1;
                                that.exportTotalCount = 0;
                                that.saveLoading = false;
                                that.showExportMsg = false;
                                that.$util.successMsg('导出成功');
                            });
                    } else {
                        that.currtPage++;
                        that.exportData();
                    }
                })
                .catch(() => {
                    that.percentage = 0;
                    that.saveCount = 0;
                    that.currtPage = 1;
                    that.exportTotalCount = 0;
                    that.saveLoading = false;
                    that.showExportMsg = false;
                });
        },  
        closeSearchDialog() {
            this.searchDialogVisible = false;
        },
        showSearchDialog() {
            this.searchDialogVisible = true;
        },      
        async searchAutoSerise(key) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            if (this.autoSeriseForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...data];
            }
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },
        coProjectsVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.projectsList.length == 0) that.getCoProjects();
            }
        },
        getCoProjects() {
            this.$util.getAuthCoProjects().then(data => {
                this.projectsList = data;
            });
        },
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 16.6%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}
.ops-ctn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .image-sup {
        width: 25px;
        height: 25px;
        margin-right: 4px;
    }
    .image-cus {
        width: 25px;
        height: 25px;
    }
}
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 9999;
}
.exportmsg {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10000;
    position: absolute;
    top: 48vh;
    left: 55vh;
    font-size: 22px;
    color: rgb(243, 62, 62);
}
</style>